
export const keyValueConstructor = (data) => {
    let a = 0, b = 1
    let new_data = data.map((itm, ind) => {
        return { name: itm[Object.keys(itm)[a]], value: itm[Object.keys(itm)[b]] };
        // let [name, value] = Object.values(itm)
        // return { name, value }
    });
    return new_data;
}


export const convertDecimal3 = (data) => {
    if (data <= 0) {
        return 0
    } else {
        return Number(data).toFixed(3)
    }
}

/*
 function to construct array structure for trend line graph 
 @discription volume data from api will parse to this function and this
  function construct data stucture formate for trend line graph representation
 @params array (volume data)
 */
export const trendLineConstruct = (data) => {
    let month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    let years = []
    let ar_ = [];
    years.push({ name: Object.keys(data[data.length - 2])[0].toString(), flag: true })
    years.push({ name: Object.keys(data[data.length - 1])[0].toString(), flag: true })
    // d/ata.filter((itm, ind) => {
    //     return (
    //         years.push({ name: Object.keys(itm).toString(), flag: true })
    // )
    // })
    for (var i = 0; i < month.length; i++) {
        ar_.push({ name: month[i] })
        for (var j = 1; j < 3; j++) {
            // console.log(data[data.length - j][`${Object.keys(data[data.length - j])[0]}`][`${month[i]}`])
            // console.log(Object.keys(data[data.length - j])[0])
            // console.log(data[j][`${Object.keys(data[j])[0]}`][`${month[i]}`])
            // console.log(data[j][`${Object.keys(data[j])[0]}`][`${month[j]}`])
            // console.log(Object.keys(data[j])[0].month[j]);
            // ar_[i][`${[`${Object.keys(data[data.length - j])}`][0]}`] = Math.floor(Math.random() * 10000);
            // ar_[i][`${[`${Object.keys(data[j])}`][0]}`] = data[j][`${Object.keys(data[j])[0]}`][`${month[i]}`];
            ar_[i][`${Object.keys(data[data.length - j])[0]}`] = data[data.length - j][`${Object.keys(data[data.length - j])[0]}`][`${month[i]}`];
        }
        // count++;
    }
    return [ar_, years]
}

/*
 function to construct array structure for bar graph 
 @discription QuaterVolume data from api will parse to this function and this
  function construct data stucture formate for bar  graph representation
 @params array (QuaterVolume data)
 */
export const barGraphConstruct = (data) => {
    // console.log(data)
    let quater = ['q1', 'q2', 'q3', 'q4'];
    let years = [];
    let ar_ = [];
    data.filter(itm => {
        return years.push({ name: Object.keys(itm), flag: true })
    })
    for (var i = 0; i < quater.length; i++) {
        ar_.push({ name: quater[i] })
        for (var j = 0; j < data.length; j++) {
            // ar_[i][`${[`${Object.keys(data[j])}`][0]}`] = Math.floor(Math.random() * 10000);
            ar_[i][`${[`${Object.keys(data[j])}`][0]}`] = data[j][`${Object.keys(data[j])[0]}`][`${quater[i]}`];
        }
        // count++;
    }
    return [ar_, years]
}


/*
 function to construct array structure for bar graph 
 @discription QuaterVolume data from api will parse to this function and this
  function construct data stucture formate for bar  graph representation
 @params array (QuaterVolume data)
 */
export const barGraphConstructHalfVolume = (data) => {
    // console.log(data)
    let half = ['h1', 'h2'];
    let years = [];
    let ar_ = [];
    data.filter(itm => {
        return years.push({ name: Object.keys(itm).toString(), flag: true })
    })
    for (var i = 0; i < half.length; i++) {
        ar_.push({ name: half[i] })
        for (var j = 0; j < data.length; j++) {
            // ar_[i][`${[`${Object.keys(data[j])}`][0]}`] = Math.floor(Math.random() * 10000);
            ar_[i][`${[`${Object.keys(data[j])}`][0]}`] = data[j][`${Object.keys(data[j])[0]}`][`${half[i]}`];
        }
    }
    return [ar_, years]
}

export const totalYoyGraphConstruct = (data) => {
    // console.log(data)
    let result = data.map((itm, ind) => {
        // console.log(Object.keys(itm)[0])
        // console.log(Object.values(itm)[0])
        return { name: Object.keys(itm)[0], value: Object.values(itm)[0] }
        // return { name: Object.keys(itm)[0], value: Math.floor(Math.random() * 10000) }
    })
    return result
}





/*
//@function generateVolumeGrowth
//@description this function generate array of years from data set comes from api result
//@params arrayOfObject (data.total) 
*/
export const generateVolumeGrowth = (data) => {
    let ar_ = [];
    ar_ = data.map((itm, ind) => {
        // console.log(itm[Object.keys(itm)[0]].Volume)
        // console.log(Object.keys(itm)[0]['Volume'])Math.floor(Math.random() * 10000)
        // return { name: Object.keys(itm)[0], value: Math.floor(Math.random() * 10000), growth: Math.floor(Math.random() * 10000) }
        return { name: Object.keys(itm)[0], value: itm[Object.keys(itm)[0]].Volume, growth: itm[Object.keys(itm)[0]].Growth }
    })
    return ar_
}



export const generateCoctRobGraphObj = (totalVol, coctrobObj) => {
    // var d = new Date();
    let sum = coctrobObj.CoreType[0].ROB.Volume + coctrobObj.CoreType[1].COTC.Volume
    let resultArr = []
    let contribution_rob = (coctrobObj.CoreType[0].ROB.Volume / sum) * 100;
    let contribution_cotc = (coctrobObj.CoreType[1].COTC.Volume / sum) * 100;
    resultArr.push({
        name: "ROB",
        value: Number(coctrobObj.CoreType[0].ROB.Volume.toFixed(0)),
        growth: coctrobObj.CoreType[0].ROB.Growth.toFixed(0),
        contribution: isNaN(contribution_rob) ? 0 : contribution_rob.toFixed(0),
        num: 25
    })
    resultArr.push({
        name: "COTC",
        value: Number(coctrobObj.CoreType[1].COTC.Volume.toFixed(0)),
        growth: coctrobObj.CoreType[1].COTC.Growth.toFixed(0),
        contribution: isNaN(contribution_cotc) ? 0 : contribution_cotc.toFixed(0),
        num: 120
    })
    // let resultArr = coctrobObj.CoreType.map((itm, ind) => {
    //     return (
    //         {
    //             name: Object.keys(itm)[0],
    //             value: (itm[`${Object.keys(itm)[0]}`]['Volume']).toFixed(0),
    //             // value: 45,
    //             growth: (itm[`${Object.keys(itm)[0]}`]['Growth']).toFixed(0),
    //             // growth: 65,
    //             // contribution: ((totalVol[totalVol.length - 1][`${d.getFullYear()}`] / itm[`${Object.keys(itm)[0]}`]['Volume']) * 100).toFixed(0),
    //             // contribution: ((totalVol[totalVol.length - 1][`${d.getFullYear()}`] / itm[`${Object.keys(itm)[0]}`]['Volume']) * 100).toFixed(0),
    //             num: ind == 0 ? 25 : 120
    //         }
    //     )
    // })
    return resultArr
}


export const generateF_C_A_C_LineGraph = (data) => {
    // console.log("DATA GRAPH",Object.entries(data))
    let resultAr = []
    if(data.hasOwnProperty('TotalDemand')){
        if(Object.entries(data.TotalDemand).length){
            Object.entries(data.TotalDemand).forEach(item=>{
                item[1]['name'] = item[0]
                resultAr.push(item[1]);
            })
        }
    }
    // if (Object.entries(data).length) {
    //     resultAr = Object.entries(data.Forecast).map(([key, value], ind) => {
    //         return (
    //             {
    //                 name: key,
    //                 actual: Object.entries(data.Actuals)[ind] ? Object.entries(data.Actuals)[ind][1] : 0,
    //                 forecast: value,
    //                 secondarySale: Object.entries(data.Secondary)[ind] ? Object.entries(data.Secondary)[ind][1] : 0,
    //             }
    //         )
    //     })
    // }
    // let resultAr = data.map(itm => {
    //     return (
    //         {
    //             week: itm.WeekNo,
    //             actual: Number(itm.PrimarySalesActual),
    //             forecast: Number(itm.ForecastBaselineMG) + Number(itm.ForecastActivatedMG) + Number(itm.ForecastTotalHG)
    //         }
    //     )
    // })
    return resultAr.length ? resultAr : []
}


export const valueConverter = (value, text) => {

    if (!value) {
        return value
    }
    else {
        if (value >= 1000000000) {
            let convertToBillion = value / 1000000000
            return convertToBillion.toFixed(2) + 'B'
        }
        else if (value >= 1000000) {
            let convertToMillion = value / 1000000
            return convertToMillion.toFixed(2) + 'M'
        } else {
            return Number.parseInt(value.toFixed(2)).toLocaleString()
        }
    }
}

export const valueConverter_2 = (value, text) => {
    // console.log("text=>",text)
    if (value === null) {
        return value
    } else {
        if (value.length > 10) {
            let billionFormate = value / 1000000000
            if (billionFormate >= 100) {
                return billionFormate + `B`
            } else {
                // console.log(Number(value.toFixed(0)).toLocaleString(),text)
                // console.log("Number(value).toLocaleString()=>",Number(value).toLocaleString())
                return Number(value).toLocaleString()
            }
            // console.log(billionFormate.toFixed(2), text)
        } else {
            // console.log("Number(value).toLocaleString()=>",Number(value).toLocaleString())
            return Number(value).toLocaleString()
            // console.log(Number(value.toFixed(0)).toLocaleString(), text)
        }
    }
}

export const getCookie = (name) => {
    var cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i].trim();
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

export const setHeaders = (contentType = false, Authorization = null, CSRF = false) => {
    let headers = {};
    if (contentType) { headers["Content-type"] = "application/json" }
    if (Authorization) { headers["Authorization"] = `Bearer ${Authorization}` }
    if (CSRF) { headers["X-CSRFToken"] = getCookie('csrftoken') }
    return { ...headers }
}

export const safeDraftSuccessDataRevamp = (data) => {
    let newObjForSafeDraft = { ActivityMetadata: {}, PreOpso: {}, guid: "" }
    newObjForSafeDraft = { ...data }
    if (Object.keys(data.ActivityMetadata).length > 1) {
        newObjForSafeDraft.ActivityMetadata = data.ActivityMetadata
    } else {
        newObjForSafeDraft.ActivityMetadata = {}
    }
    return newObjForSafeDraft
}

export default function GoToEmailVerificationScreen(flag) {
    // console.log(useHistory())
    // return <Redirect to="/verification" />
}
